export default __webpack_public_path__ + "static/media/fasteners.48dc4575.webp";